import React, { useState, useEffect } from "react";
import { Button, Table, Form } from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";
import NewTopNavBar from "../NewTopNavBar";
import { FaEdit, FaPlus, FaLink } from "react-icons/fa";
import { toast } from "react-toastify";
import { FaSync } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import swichImg from "../../Img/settings.png"
import { FaRegSave } from "react-icons/fa";
import { PencilSquare, Trash, Check, X, Check2Circle, XCircle } from "react-bootstrap-icons"
const ManageCredentials = () => {
  const [zohoData, setZohoData] = useState({
    clientID: "",
    clientSecret: "",
    redirectURI: "",
    projectName: "",
    projectID: "",
    portal_id: "",
  });
  const [jiraData, setJiraData] = useState({
    userID: "",
    password: "",
    base_url: "",
    projectName: "",
    projectID: "",
  });

  const [serviceNowData, setServiceNowData] = useState({
    userID: "",
    password: "",
    base_url: "",
    projectName: "",
    projectID: "",
  });

  const [isZohoEditMode, setIsZohoEditMode] = useState(false);
  const [adminEditMode,setAdminEditMode]=useState(false)
  const [isJiraEditMode, setIsJiraEditMode] = useState(false);
  const [isServiceNowMode, setIsServiceNowMode] = useState(false);
  const [existingZohoData, setExistingZohoData] = useState(null);
  const [existingJiraData, setExistingJiraData] = useState(null);
  const [existingServiceNowData, setExistingServiceNowData] = useState(null);
  const [exsistingGlobalCreds, setExsistingGlobalCreds] = useState(null)
  const [manageGlobalValue, setManageGlobalValue] = useState(false)
  const [platform,setPlatform ]=useState('')
  const [globalCreds, setGloablCreds] = useState({
    redirectURI: "",
    projectName: "",
    projectID: "",
    portal_id: "",
  })
  const userRoles = localStorage.getItem('roles');

  const selectedPlatform=()=>{
    const token = localStorage.getItem("jwt_token");
    const config = {
      
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
     
    };
    axios.get(`${API_BASE_URL}/wp-json/custom/v1/tenant-conf-modules`,config).then((res)=>{
      console.log('resdata63=',res.data)
      setPlatform(res.data[0].vendor_ticketing_system)
    }).catch((err)=>{
      console.log(err)
    })
  }

  const fetchExistingCredentials = async () => {
    try {
      const userEmail = localStorage.getItem("userEmail");
      const token = localStorage.getItem("jwt_token");

      if (!userEmail || !token) {
        toast.error("User email or token is missing.");
        return;
      }

      const config = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: { email: userEmail },
      };
      const config2 = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },

      };

      const jiraResponse = await axios.get(
        `${API_BASE_URL}/wp-json/custom-api/v1/jira`,
        config
      );
      const serviceNowResponse = await axios.get(
        `${API_BASE_URL}/wp-json/custom-api/v1/service_now`,
        config
      );

      const zohoResponse = await axios.get(
        `${API_BASE_URL}/wp-json/custom-api/v1/zoho`,
        config
      );
      const zohoGlobalRes = await axios.get(`${API_BASE_URL}/wp-json/zoho/v1/get-global-credentials`,
        config2)
      console.log('zohoglobal=', zohoGlobalRes.data.projectName)

      // setExistingJiraData(jiraResponse.data.data);
      // setExistingZohoData(zohoResponse.data.data);

      if (zohoGlobalRes.data) {
        // setExsistingGlobalCreds(zohoGlobalRes.data)
        // setGloablCreds(zohoGlobalRes.data)
        setExsistingGlobalCreds({
          redirectURI: zohoGlobalRes.data.redirectURI,
          projectName: zohoGlobalRes.data.projectName,
          projectID: zohoGlobalRes.data.projectID,
          portal_id: zohoGlobalRes.data.portal_id,
        });
        setGloablCreds({
          redirectURI: zohoGlobalRes.data.redirectURI,
          projectName: zohoGlobalRes.data.projectName,
          projectID: zohoGlobalRes.data.projectID,
          portal_id: zohoGlobalRes.data.portal_id,
        });

      }

      console.log("jiraResponse=", serviceNowResponse)

      if (serviceNowResponse.data.data) {
        setExistingServiceNowData({
          userID: serviceNowResponse.data.data.user_id,

          password: serviceNowResponse.data.data.password || "",
          base_url: serviceNowResponse.data.data.base_url || "",

        });
        setServiceNowData({
          userID: serviceNowResponse.data.data.user_id,

          password: serviceNowResponse.data.data.password || "",
          base_url: serviceNowResponse.data.data.base_url || "",
        });
      }

      if (jiraResponse.data.data) {
        setExistingJiraData({
          userID: jiraResponse.data.data.user_id,
          email: jiraResponse.data.data.email,
          password: jiraResponse.data.data.password || "",
          base_url: jiraResponse.data.data.base_url || "",
          projectName: jiraResponse.data.data.projectName || "",
          projectID: jiraResponse.data.data.projectID || "",
        });
        setJiraData({
          userID: jiraResponse.data.data.user_id,
          email: jiraResponse.data.data.email,
          password: jiraResponse.data.data.password || "",
          base_url: jiraResponse.data.data.base_url || "",
          projectName: jiraResponse.data.data.projectName || "",
          projectID: jiraResponse.data.data.projectID || "",
        });
      }
      console.log(
        "jiraResponse.data.data::---------------" + jiraResponse.data.data
      );
      if (zohoResponse.data.data) {
        setZohoData({
          clientID: zohoResponse.data.data.clientID,
          clientSecret: zohoResponse.data.data.clientSecret,
          redirectURI: zohoResponse.data.data.redirectURI,
          projectName: zohoResponse.data.data.projectName,
          projectID: zohoResponse.data.data.projectID,
          portal_id: zohoResponse.data.data.portal_id,
        });
        setExistingZohoData({
          clientID: zohoResponse.data.data.clientID,
          clientSecret: zohoResponse.data.data.clientSecret,
          redirectURI: zohoResponse.data.data.redirectURI,
          projectName: zohoResponse.data.data.projectName,
          projectID: zohoResponse.data.data.projectID,
          portal_id: zohoResponse.data.data.portal_id,
          verification_status: zohoResponse.data.data.verification_status,
        });
      }
    } catch (error) {
      console.error("Error fetching existing credentials:", error);
      toast.error("Error fetching credentials.");
    }
  };


  // console.log("existingglobla=", exsistingGlobalCreds)

  const handleRefresh = async () => {
    try {
      fetchExistingCredentials();
      toast.success(`Latest details fetched.`);
    } catch (error) {
      console.error(`Error fetching `, error);
    }
  };

  useEffect(() => {
    fetchExistingCredentials();
    selectedPlatform()
  }, []);

  const handleInputChange = (e, platform) => {
    // alert(manageGlobalValue)
    // manageGlobalValue=true
    const { name, value } = e.target;
    console.log("value=",e.target.value)
    if (platform === "zoho" && manageGlobalValue == false) {
      setZohoData((prev) => ({ ...prev, [name]: value }));
      // setGloablCreds((prev) => ({ ...prev, [name]: value }))
    } else if (platform === "zoho" && manageGlobalValue) {
      setGloablCreds((prev) => ({ ...prev, [name]: value }))
    } else if (platform == 'service') {
      setServiceNowData((prev) => ({ ...prev, [name]: value }))
    }

    else {
      setJiraData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async (platform) => {
    const data = platform === "zoho" ? zohoData : jiraData;
    const userEmail = localStorage.getItem("userEmail");

    if (!userEmail) {
      toast.error("User email is missing.");
      return;
    }
    // const url =
    //   platform === "zoho"
    //     ? `${API_BASE_URL}/wp-json/custom-api/v1/zoho`
    //     : platform === "jira"
    //       ? `${API_BASE_URL}/wp-json/custom-api/v1/jira`
    //       : platform === "service"
    //         ? `${API_BASE_URL}/wp-json/custom-api/v1/service_now`
    //         : "";
    const url =
      platform === "zoho"
        ? `${API_BASE_URL}/wp-json/custom-api/v1/zoho`
        : `${API_BASE_URL}/wp-json/custom-api/v1/jira`;

    // if (platform == "zoho" && manageGlobalValue) {
    //   url = `${API_BASE_URL}/wp-json/zoho/v1/store-global-credentials`
    // } else if (platform == "zoho" && manageGlobalValue == false) {
    //   url = `${API_BASE_URL}/wp-json/custom-api/v1/zoho`
    // } else {
    //   url = `${API_BASE_URL}/wp-json/custom-api/v1/jira`
    // }

    console.log(`serviceNow, ${platform}`);
    console.log("platform=", serviceNowData)
    if (platform == "zoho" && manageGlobalValue) {
      // alert(manageGlobalValue)
      const globalData = {
        redirectURI: globalCreds.redirectURI,
        projectName: globalCreds.projectName,
        projectID: globalCreds.projectID,
        portal_id: globalCreds.portal_id
      }
      //      const globalData = {
      //   redirectURI: zohoData.redirectURI,
      //   projectName: zohoData.projectName,
      //   projectID: zohoData.projectID,
      //   portal_id: zohoData.portal_id
      // }
      try {
        await axios.post(
          `${API_BASE_URL}/wp-json/zoho/v1/store-global-credentials`,
          globalData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
            },
          }
        );

        toast.success(
          `${platform.toUpperCase()} credentials saved successfully.`
        );
        fetchExistingCredentials();
        setIsZohoEditMode(false);
        setIsJiraEditMode(false);
        setIsServiceNowMode(false)
        setAdminEditMode(false)
      } catch (error) {
        console.error(`Error saving ${platform} credentials:`, error);
        toast.error(`Failed to save ${platform} credentials.`);
      }
    } else if (platform == "jira" && manageGlobalValue) {
      try {
        await axios.post(
          `${API_BASE_URL}/wp-json/jira/v1/store-global-credentials`,
          {
            projectName: data.projectName,
            base_url: data.base_url,
            projectID: data.projectID
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
            },
          }
        );

        toast.success(
          `${platform.toUpperCase()} credentials saved successfully.`
        );
        fetchExistingCredentials();
        setIsZohoEditMode(false);
        setIsJiraEditMode(false);
        setIsServiceNowMode(false)
        setAdminEditMode(false)
      } catch (error) {
        console.error(`Error saving ${platform} credentials:`, error);
        toast.error(`Failed to save ${platform} credentials.`);
      }
    } else if (platform === "service" && manageGlobalValue) {
      try {
        await axios.post(
          `${API_BASE_URL}/wp-json/service_now/v1/store-global-credentials`,
          {

            base_url: serviceNowData.base_url,

          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
            },
          }
        );

        toast.success(
          `ServiceNow credentials saved successfully.`
        );
        fetchExistingCredentials();
        setIsZohoEditMode(false);
        setIsJiraEditMode(false);
        setIsServiceNowMode(false)
        setAdminEditMode(false)
      } catch (error) {
        console.error(`Error saving ${platform} credentials:`, error);
        toast.error(`Failed to save ServiceNow credentials.`);
      }
    } else if (platform === "service" && manageGlobalValue === false) {
      try {
        await axios.post(
          `${API_BASE_URL}/wp-json/custom-api/v1/service_now`,
          {
            user_id: serviceNowData.userID,
            base_url: serviceNowData.base_url,
            password: serviceNowData.password,
            email: userEmail,

          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
            },
          }
        );

        toast.success(
          `ServiceNow credentials saved successfully.`
        );
        fetchExistingCredentials();
        setIsZohoEditMode(false);
        setIsJiraEditMode(false);
        setIsServiceNowMode(false)
        setAdminEditMode(false)
      } catch (error) {
        console.error(`Error saving ${platform} credentials:`, error);
        toast.error(`Failed to save ServiceNow credentials.`);
      }
    }
    else {
      // alert(platform)
      console.log('data230=', data)
      try {
        await axios.post(
          url,
          // `${API_BASE_URL}/wp-json/jira/v1/store-global-credentials`,
          {
            // projectName: data.projectName,
            // base_url: data.base_url,
            // projectID: data.projectID
            ...data,
            email: userEmail,
            user_id: data.userID,
            verification_status: "not-verified",
            refresh_token: "refresh_token",
            access_token: "access_token",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
            },
          }
        );

        toast.success(
          `${platform.toUpperCase()} credentials saved successfully.`
        );
        fetchExistingCredentials();
        setIsZohoEditMode(false);
        setIsJiraEditMode(false);
        setIsServiceNowMode(false)
        setAdminEditMode(false)
      } catch (error) {
        console.error(`Error saving ${platform} credentials:`, error);
        toast.error(`Failed to save ${platform} credentials.`);
      }
    }
  };

  const openZohoOAuth = () => {
    const { clientID, redirectURI } = zohoData;
    if (clientID && globalCreds.redirectURI) {
      const zohoOAuthURL = `https://accounts.zoho.com/oauth/v2/auth?response_type=code&access_type=offline&prompt=consent&client_id=${clientID}&redirect_uri=${globalCreds.redirectURI}?UserEmail=${localStorage.getItem('userEmail')}&scope=ZohoProjects.bugs.ALL,ZohoProjects.comments.ALL,ZohoProjects.projects.ALL,ZohoProjects.tasks.ALL,ZohoProjects.milestones.ALL,ZohoProjects.timesheets.ALL,ZohoProjects.users.ALL,ZohoProjects.portals.ALL,ZohoProjects.search.READ,ZohoFiles.files.READ`;

      window.open(zohoOAuthURL, "_blank");
    } else {
      toast.error("Please fill in the Client ID and Redirect URI.");
    }
  };

  const obfuscateString = (str = "", visibleChars = 30) => {
    if (str.length <= visibleChars * 2) {
      return str;
    }
    const start = str.slice(0, visibleChars);
    const end = str.slice(-visibleChars);
    return `${start}...${end}`;
  };
  const manageCredBtn = () => {
    setManageGlobalValue(manageGlobalValue ? false : true);
    setIsZohoEditMode(false)
    setIsJiraEditMode(false)
    setIsServiceNowMode(false)
    setAdminEditMode(false)
  }
  const globalCredEdit=()=>{
    setAdminEditMode(true)
    setManageGlobalValue(true)
  }
  const editLocalCred=()=>{
    setIsZohoEditMode(true)
     setManageGlobalValue(false)
  }
  return (
    <>
      <NewTopNavBar />
      <div className="text-center pt-5 container manage-ticket-cred-main-div">
      
        
        {userRoles == 'administrator' || userRoles == 'editor' ?
          <div className="pb-3 text-end">
            <button  className="btn-manage-project d-none" onClick={() => manageCredBtn()}>
              {manageGlobalValue ? <img title="Manage Credentials" src={swichImg}/>  : <img title="Manage Project" src={swichImg}/> }
            </button>
            {/* <Button ></Button> */}

            <h4 className="pb-4 text-center">Manage Organizational Credentials</h4>
        <Table striped bordered hover>
        <thead >
              <tr>
                <th className="text-center align-middle">Platform</th>
                <th className="text-center align-middle">Portal ID / Base URL</th>
                <th className="text-center align-middle">Project Name</th>
                <th className="text-center align-middle">Project ID</th>
                <th className="text-center align-middle">Redirect URI</th>
                <th className="text-center align-middle">Action</th>
              </tr>
          </thead>
          <tbody>
          <tr className={platform=='zoho'?'':'table-disabled'}>
                <td className="text-center align-middle">Zoho  </td>
                <td className="text-center py-2 align-middle">
                  {adminEditMode ? (
                    <Form.Control
                      type="text"
                      name="portal_id"
                      value={globalCreds.portal_id}
                        // value={zohoData.portal_id}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Portal ID"
                    />
                  ) : (
                    exsistingGlobalCreds?.portal_id || "--"
                  )}
                </td>
                <td className="text-center py-2 align-middle">
                  {adminEditMode ? (
                    <Form.Control
                      type="text"
                      name="projectName"
                      value={globalCreds.projectName}
                      // value={zohoData.projectName}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Project Name"
                    />
                  ) : (
                    exsistingGlobalCreds?.projectName || "--"
                  )}
                </td>
                <td className="text-center py-2 align-middle">
                  {adminEditMode ? (
                    <Form.Control
                      type="text"
                      name="projectID"
                      value={globalCreds.projectID}
                      // value={zohoData.projectID}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Project ID"
                    />
                  ) : (
                    exsistingGlobalCreds?.projectID || "--"
                  )}
                </td>

                <td className="text-center py-2 align-middle">
                  {adminEditMode ? (
                    <Form.Control
                      type="text"
                      name="redirectURI"
                      value={globalCreds.redirectURI}
                      //  value={zohoData.redirectURI}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Redirect URI"
                    />
                  ) : (
                    <span
                      title={exsistingGlobalCreds?.redirectURI}
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          exsistingGlobalCreds?.redirectURI
                        );
                        toast("URI Copied!");
                      }}
                    >
                      URI
                    </span>
                  )}
                </td>
                <td style={{ whiteSpace: "nowrap" }}  className="text-center p-0 align-middle">
                  
                  {adminEditMode ? (
                    <>
                    <Button
                      variant=""
                      title="save"
                      onClick={() => handleSave("zoho")}
                    >
                      <FaRegSave />
                    </Button>
                    
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setAdminEditMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>

                    
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        onClick={() => globalCredEdit()}
                      >
                        <FaEdit />
                      </Button>
                      {existingZohoData?.clientSecret &&
                        existingZohoData?.redirectURI &&
                        existingZohoData?.clientID &&
                        existingZohoData.verification_status ===
                        "not-verified" && (
                          <>
                            {/* <Button
                              variant=""
                              title="Approve"
                              onClick={openZohoOAuth}
                              className="ml-2"
                            >
                              <FaLink /> Approve
                            </Button> */}
                            <Button
                              variant=""
                              title="Refresh"
                              onClick={() => handleRefresh()}
                              className="ml-2"
                            >
                              <FaSync />
                            </Button>
                          </>
                        )}
                    </>
                  )}
                  
                </td>
              </tr>
              <tr className={platform=='jira'?'':'table-disabled'}>
                <td className="text-center ">Jira</td>

                <td className="text-center py-2">
                  {adminEditMode ? (
                    <Form.Control
                      type="text"
                      name="base_url"
                      value={jiraData.base_url}
                      onChange={(e) => handleInputChange(e, "jira")}
                      placeholder="Enter Base URL"
                    />
                  ) : (
                    existingJiraData?.base_url || "--"
                  )}
                </td>
                <td className="text-center py-2">
                  {adminEditMode ? (
                    <Form.Control
                      type="text"
                      name="projectName"
                      value={jiraData.projectName}
                      onChange={(e) => handleInputChange(e, "jira")}
                      placeholder="Enter Project Name"
                    />
                  ) : (
                    existingJiraData?.projectName || "--"
                  )}
                </td>
                <td className="text-center py-2">
                  {adminEditMode ? (
                    <Form.Control
                      type="text"
                      name="projectID"
                      value={jiraData.projectID}
                      onChange={(e) => handleInputChange(e, "jira")}
                      placeholder="Enter Project ID"
                    />
                  ) : (
                    existingJiraData?.projectID || "--"
                  )}
                </td>
                <td className="text-center" colSpan="1">
                  —
                </td>
                <td className="text-center p-0">
                  
                  {adminEditMode ? (
                    <>
                    <Button
                      variant=""
                       title="save"
                      onClick={() => handleSave("jira")}
                    >
                      {/* Save */}
                      <FaRegSave />
                    </Button>
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setAdminEditMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        onClick={() => setAdminEditMode(true)}
                      >
                        <FaEdit />
                      </Button>

                      <Button
                        variant=""
                        title="Refresh"
                        onClick={() => handleRefresh()}
                        className="ml-2"
                      >
                        <FaSync />
                      </Button>


                    </>
                  )}
                 
                </td>
              </tr>
              <tr className={platform=='ServiceNow'?'':'table-disabled'}>
                <td className="text-center">ServiceNow</td>

                <td className="text-center py-2">
                  {adminEditMode ? (
                    <Form.Control
                      type="text"
                      name="base_url"
                      value={serviceNowData.base_url}
                      onChange={(e) => handleInputChange(e, "service")}
                      placeholder="Enter Base URL"
                    />
                  ) : (
                    serviceNowData?.base_url || "--"
                  )}
                </td>

                <td className="text-center" colSpan="1">
                  —
                </td>
                <td className="text-center" colSpan="1">
                  —
                </td>
                <td className="text-center" colSpan="1">
                  —
                </td>
                <td className="text-center p-0">
                  
                  {adminEditMode ? (
                    <>
                    <Button
                      variant=""
                       title="save"
                      onClick={() => handleSave("service")}
                    >
                      {/* Save */}
                      <FaRegSave />
                    </Button>
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setAdminEditMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        onClick={() => setAdminEditMode(true)}
                      >
                        <FaEdit />
                      </Button>

                      <Button
                        variant=""
                        title="Refresh"
                        onClick={() => handleRefresh()}
                        className="ml-2"
                      >
                        <FaSync />
                      </Button>


                    </>
                  )}
                  
                </td>
              </tr>
          </tbody>
        </Table>

          </div> : ""}
          <h4 className="py-4"> {manageGlobalValue ? "Manage Project " : "Manage User Credentials"}</h4>
          <Table striped bordered hover>
          <thead>
            {/* {manageGlobalValue ?
              <tr>
                <th className="text-center">Platform</th>
                <th className="text-center">Portal ID / Base URL</th>
                <th className="text-center">Project Name</th>
                <th className="text-center">Project ID</th>
                <th className="text-center">Redirect URI</th>
                <th className="text-center">Action</th>
              </tr>
              :  */}
              <tr>
                <th className="text-center">Platform</th>
                <th className="text-center">Client ID</th>
                <th className="text-center">Client Secret</th>
                <th className="text-center" style={{width:'20%'}}>Action</th>
              </tr>
            {/* } */}
          </thead>
        
          <tbody className="userCredTable">
            {console.log("globalcred=", globalCreds)}
            {/* {manageGlobalValue ?

              <tr className={platform=='zoho'?'':'table-disabled'}>
                <td className="text-center">Zoho</td>
                <td className="text-center py-2">
                  {isZohoEditMode ? (
                    <Form.Control
                      type="text"
                      name="portal_id"
                      value={globalCreds.portal_id}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Portal ID"
                    />
                  ) : (
                    exsistingGlobalCreds?.portal_id || "--"
                  )}
                </td>
                <td className="text-center py-2">
                  {isZohoEditMode ? (
                    <Form.Control
                      type="text"
                      name="projectName"
                      value={globalCreds.projectName}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Project Name"
                    />
                  ) : (
                    exsistingGlobalCreds?.projectName || "--"
                  )}
                </td>
                <td className="text-center py-2">
                  {isZohoEditMode ? (
                    <Form.Control
                      type="text"
                      name="projectID"
                      value={globalCreds.projectID}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Project ID"
                    />
                  ) : (
                    exsistingGlobalCreds?.projectID || "--"
                  )}
                </td>

                <td className="text-center py-2">
                  {isZohoEditMode ? (
                    <Form.Control
                      type="text"
                      name="redirectURI"
                      value={globalCreds.redirectURI}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Redirect URI"
                    />
                  ) : (
                    <span
                      title={exsistingGlobalCreds?.redirectURI}
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          exsistingGlobalCreds?.redirectURI
                        );
                        toast("URI Copied!");
                      }}
                    >
                      URI
                    </span>
                  )}
                </td>
                <td style={{ whiteSpace: "nowrap" }}  className="text-center p-0">
                  
                  {isZohoEditMode ? (
                    <>
                    <Button
                      variant=""
                      title="save"
                      onClick={() => handleSave("zoho")}
                    >
                      <FaRegSave />
                    </Button>
                    sfsfs
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setIsZohoEditMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        onClick={() => setIsZohoEditMode(true)}
                      >
                        <FaEdit />
                      </Button>
                      {existingZohoData?.clientSecret &&
                        existingZohoData?.redirectURI &&
                        existingZohoData?.clientID &&
                        existingZohoData.verification_status ===
                        "not-verified" && (
                          <>
                         
                            <Button
                              variant=""
                              title="Refresh"
                              onClick={() => handleRefresh()}
                              className="ml-2"
                            >
                              <FaSync />
                            </Button>
                          </>
                        )}
                    </>
                  )}
                  
                </td>
              </tr>
              :  */}
              
              <tr className={platform=='zoho'?'':'table-disabled'}>
                <td className="text-center">Zoho</td>
                <td className="text-center py-2">
                  {isZohoEditMode ? (
                    <Form.Control
                      type="text"
                      name="clientID"
                      value={zohoData.clientID}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Client ID"
                    />
                  ) : existingZohoData?.clientID ? (
                    obfuscateString(existingZohoData?.clientID)
                  ) : (
                    "--"
                  )}
                </td>
                <td className="text-center py-2">
                  {isZohoEditMode ? (
                    <Form.Control
                      type="password"
                      name="clientSecret"
                      value={zohoData.clientSecret}
                      onChange={(e) => handleInputChange(e, "zoho")}
                      placeholder="Enter Client Secret"
                    />
                  ) : existingZohoData?.clientSecret ? (
                    existingZohoData.clientSecret.length > 30 ? (
                      // `${existingZohoData.clientSecret.slice(
                      //   0,
                      //   30
                      // )}...${existingZohoData.clientSecret.slice(-6)}`
                      '•'.repeat(30)
                    ) 
                    : (
                      // existingZohoData.clientSecret
                      '•'.repeat(existingZohoData.clientSecret.length)
                    )
                  ) : (
                    "--"
                  )}
                </td>

                <td style={{ whiteSpace: "nowrap" }} className="text-center p-0">
                
                  {isZohoEditMode ? (
                    <>
                    <Button
                      variant=""
                      title="save"
                      onClick={() => handleSave("zoho")}
                    >
                      <FaRegSave />
                    </Button>
                    
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setIsZohoEditMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        // onClick={() => setIsZohoEditMode(true)}
                         onClick={() => editLocalCred(true)}
                      >
                        <FaEdit />
                      </Button>
                      {/* {existingZohoData?.clientSecret &&
                        existingZohoData?.redirectURI &&
                        existingZohoData?.clientID &&
                        existingZohoData.verification_status ===
                        "not-verified" && ( */}
                      <>
                        <Button
                          variant=""
                          title="Approve"
                          onClick={openZohoOAuth}
                          className="ml-2"
                        >
                          {/* <FaLink />  */}
                          <TiTick size={20}/>
                        </Button>
                        <Button
                          variant=""
                          title="Refresh"
                          onClick={() => handleRefresh()}
                          className="ml-2"
                        >
                          <FaSync />
                        </Button>
                      </>
                      {/* )} */}
                    </>
                  )}
                  
                </td>
              </tr>

            {/* } */}
            {manageGlobalValue ?
              <tr className={platform=='jira'?'':'table-disabled'}>
                <td className="text-center ">Jira</td>

                <td className="text-center py-2">
                  {isJiraEditMode ? (
                    <Form.Control
                      type="text"
                      name="base_url"
                      value={jiraData.base_url}
                      onChange={(e) => handleInputChange(e, "jira")}
                      placeholder="Enter Base URL"
                    />
                  ) : (
                    existingJiraData?.base_url || "--"
                  )}
                </td>
                <td className="text-center py-2">
                  {isJiraEditMode ? (
                    <Form.Control
                      type="text"
                      name="projectName"
                      value={jiraData.projectName}
                      onChange={(e) => handleInputChange(e, "jira")}
                      placeholder="Enter Project Name"
                    />
                  ) : (
                    existingJiraData?.projectName || "--"
                  )}
                </td>
                <td className="text-center py-2">
                  {isJiraEditMode ? (
                    <Form.Control
                      type="text"
                      name="projectID"
                      value={jiraData.projectID}
                      onChange={(e) => handleInputChange(e, "jira")}
                      placeholder="Enter Project ID"
                    />
                  ) : (
                    existingJiraData?.projectID || "--"
                  )}
                </td>
                <td className="text-center" colSpan="1">
                  —
                </td>
                <td className="text-center p-0">
                  
                  {isJiraEditMode ? (
                    <>
                    <Button
                      variant=""
                       title="save"
                      onClick={() => handleSave("jira")}
                    >
                      {/* Save */}
                      <FaRegSave />
                    </Button>
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setIsJiraEditMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        onClick={() => setIsJiraEditMode(true)}
                      >
                        <FaEdit />
                      </Button>

                      <Button
                        variant=""
                        title="Refresh"
                        onClick={() => handleRefresh()}
                        className="ml-2"
                      >
                        <FaSync />
                      </Button>


                    </>
                  )}
                 
                </td>
              </tr>
              : <tr className={platform=='jira'?'':'table-disabled'}>
                <td className="text-center">Jira</td>
                <td className="text-center py-2">
                  {isJiraEditMode ? (
                    <Form.Control
                      type="text"
                      name="userID"
                      value={jiraData.userID}
                      onChange={(e) => handleInputChange(e, "jira")}
                      placeholder="Enter User ID"
                    />
                  ) : (
                    existingJiraData?.userID || "--"
                  )}
                </td>
                <td className="text-center">
                  {isJiraEditMode ? (
                    <Form.Control
                      type="password"
                      name="password"
                      value={jiraData.password}
                      onChange={(e) => handleInputChange(e, "jira")}
                      placeholder="Enter Password"
                    />
                  ) : existingJiraData?.password ? (
                    existingJiraData.password.length > 30 ? (
                      // `${existingJiraData.password.slice(
                      //   0,
                      //   6
                      // )}...${existingJiraData.password.slice(-6)}`
                      '•'.repeat(30)
                    ) : (
                      // existingJiraData.password
                      '•'.repeat(existingZohoData.clientSecret.length)
                    )
                  ) : (
                    "--"
                  )}
                </td>


                <td className="text-center p-0">
                  
                  {isJiraEditMode ? (
                    <>
                    <Button
                      variant=""
                       title="save"
                      onClick={() => handleSave("jira")}
                    >
                      {/* Save */}
                      <FaRegSave />
                    </Button>
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setIsJiraEditMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        onClick={() => setIsJiraEditMode(true)}
                      >
                        <FaEdit />
                      </Button>
                      {/* {existingZohoData?.clientSecret &&
                        existingZohoData?.redirectURI &&
                        existingZohoData?.clientID &&
                        existingZohoData.verification_status ===
                        "not-verified" && ( */}
                      <>
                        {/* <Button
                              variant=""
                              title="Approve"
                              onClick={openZohoOAuth}
                              className="ml-2"
                            >
                              <FaLink /> Approve
                            </Button> */}
                        <Button
                          variant=""
                          title="Refresh"
                          onClick={() => handleRefresh()}
                          className="ml-2"
                        >
                          <FaSync />
                        </Button>
                      </>
                      {/* )} */}
                    </>
                  )}
                  
                </td>
              </tr>
            }
            {/* service Now row start */}

            {manageGlobalValue ?
              <tr className={platform=='ServiceNow'?'':'table-disabled'}>
                <td className="text-center">ServiceNow</td>

                <td className="text-center py-2">
                  {isServiceNowMode ? (
                    <Form.Control
                      type="text"
                      name="base_url"
                      value={serviceNowData.base_url}
                      onChange={(e) => handleInputChange(e, "service")}
                      placeholder="Enter Base URL"
                    />
                  ) : (
                    serviceNowData?.base_url || "--"
                  )}
                </td>

                <td className="text-center" colSpan="1">
                  —
                </td>
                <td className="text-center" colSpan="1">
                  —
                </td>
                <td className="text-center" colSpan="1">
                  —
                </td>
                <td className="text-center p-0">
                  <>
                  {isServiceNowMode ? (
                    <>
                    <Button
                      variant=""
                       title="save"
                      onClick={() => handleSave("service")}
                    >
                      {/* Save */}
                      <FaRegSave />
                    </Button>
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setIsServiceNowMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        onClick={() => setIsServiceNowMode(true)}
                      >
                        <FaEdit />
                      </Button>

                      <Button
                        variant=""
                        title="Refresh"
                        onClick={() => handleRefresh()}
                        className="ml-2"
                      >
                        <FaSync />
                      </Button>


                    </>
                  )}
                  </>
                </td>
              </tr>
              : <tr className={platform=='ServiceNow'?'':'table-disabled'}>
                <td className="text-center">ServiceNow</td>
                <td className="text-center py-2">
                  {isServiceNowMode ? (
                    <Form.Control
                      type="text"
                      name="userID"
                      value={serviceNowData.userID}
                      onChange={(e) => handleInputChange(e, "service")}
                      placeholder="Enter User ID"
                    />
                  ) : (
                    serviceNowData?.userID || "--"
                  )}
                </td>
                <td className="text-center">
                  {isServiceNowMode ? (
                    <Form.Control
                      type="password"
                      name="password"
                      value={serviceNowData.password}
                      onChange={(e) => handleInputChange(e, "service")}
                      placeholder="Enter Password"
                    />
                  ) : serviceNowData?.password ? (
                    serviceNowData.password.length > 12 ? (
                      // `${serviceNowData.password.slice(
                      //   0,
                      //   6
                      // )}...${serviceNowData.password.slice(-6)}`
                      '•'.repeat(30)
                    ) : (
                      // serviceNowData.password
                      '•'.repeat(existingZohoData.clientSecret.length)
                    )
                  ) : (
                    "--"
                  )}
                </td>


                <td className="text-center p-0">
                  
                  {isServiceNowMode ? (
                    <>
                    <Button
                      variant=""
                       title="save"
                      onClick={() => handleSave("service")}
                    >
                      {/* Save */}
                      <FaRegSave />
                    </Button>
                    <Button
                      variant=""
                      title="cancle"
                      onClick={() => setIsServiceNowMode(false)}
                    >
                      <XCircle />
                    </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant=""
                        title="edit"
                        onClick={() => setIsServiceNowMode(true)}
                      >
                        <FaEdit />
                      </Button>
                      {/* {existingZohoData?.clientSecret &&
                        existingZohoData?.redirectURI &&
                        existingZohoData?.clientID &&
                        existingZohoData.verification_status ===
                        "not-verified" && ( */}
                      <>
                        {/* <Button
                              variant=""
                              title="Approve"
                              onClick={openZohoOAuth}
                              className="ml-2"
                            >
                              <FaLink /> Approve
                            </Button> */}
                        <Button
                          variant=""
                          title="Refresh"
                          onClick={() => handleRefresh()}
                          className="ml-2"
                        >
                          <FaSync />
                        </Button>
                      </>
                      {/* )} */}
                    </>
                  )}
                  
                </td>
              </tr>
            }

            {/* service now row end */}
          </tbody>
          
        </Table>
       

        {console.log(`isZohoEditMode=${isZohoEditMode} isJiraEditMode=${isJiraEditMode}`)
        }
      </div>
    </>
  );
};

export default ManageCredentials;
